import { Box, FormControlLabel, Switch } from "@mui/material";
import { type FC, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import type { PollWrapperSchema } from "./types";

export const PollResultsToggle: FC = () => {
  const { control, setValue, getValues } = useFormContext<PollWrapperSchema>();

  useWatch({ control, name: "poll.show_poll_results" });
  const show_poll_results = getValues("poll.show_poll_results");

  const handleToggle = useCallback(
    (checked: boolean) => {
      setValue("poll.show_poll_results", checked);
    },
    [setValue],
  );

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch checked={show_poll_results} onChange={(e) => handleToggle(e.target.checked)} />
        }
        label="Allow respondents to see all results after voting"
      />
    </Box>
  );
};
